import { Component, HostListener } from '@angular/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrl: './header.component.css'
})
export class HeaderComponent {
  isSticky: boolean = false;
  logo: string = 'assets/images/logo-white.png';
  isCollapsed = true;

    
  scrollToSection(sectionId: string) {
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    }
    // ✅ Auto-close the menu on link click (mobile view)
    this.isCollapsed = true;
  }

  @HostListener('window:scroll', [])
  onWindowScroll(): void {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
    this.isSticky = scrollTop > 100;
    this.logo = this.isSticky ? 'assets/images/logo-black.png' : 'assets/images/logo-white.png';
  }
}
